// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2PwT2","bigColWidth":"Table_bigColWidth__2LIUe","biggerColWidth":"Table_biggerColWidth__nt0RI","row":"Table_row__1z14m","col":"Table_col__3klS5"};